export default "__VITE_ASSET__De$uxgWQ__"